/**
 * Vite dynamic imports resolve to ESM module namespaces, while react-loadable
 * expects the component itself. Unwrap the default export when present.
 */
export function resolveLoadableModule<T>(module: T | { default: T }): T {
    if (module && typeof module === 'object' && 'default' in module) {
        return (module as { default: T }).default
    }
    return module as T
}
